import { createCommand } from 'lexical'

export const TABLE_COLUMN_COUNT_CHANGE_COMMAND = createCommand<void>(
  'TABLE_COLUMN_COUNT_CHANGE_COMMAND'
)

export const TABLE_ROW_COUNT_CHANGE_COMMAND = createCommand<void>(
  'TABLE_ROW_COUNT_CHANGE_COMMAND'
)
